// Store these here in case this gets offloaded to a webworker or API call

// Returns result of compoundGrowth
// base + (1 + growthRate), n - 1 times
// TODO: refactor this in a declarative way
export const compoundGrowth = (base: number, growthRate: number, numCycles: number): number => {
  let total = base;
  const multiplier = 1 + growthRate;
  for (let i = 0; i < numCycles; i++) {
    total *= multiplier;
  }
  return total;
}

// Return a list of all the intermediate projections
export const compoundGrowthSeries = (base: number, growthRate: number, numCycles: number): number[] => {
  const results = [base];
  let total = base;
  const multiplier = 1 + growthRate;
  for (let i = 0; i < numCycles; i++) { // skip by 1 because we include base as the first cycle
    total *= multiplier;
    results.push(total);
  }
  return results;
}

// Make a sequence of numbers, where each member is incremented by some number
export const simpleGrowthRateSeries = (base: number, growthStep: number, numCycles: number): number[] => {
  const results = [base];
  let total = base;
  for (let i = 0; i < numCycles; i++) { // skip by 1 because we include base as the first cycle
    total += growthStep;
    results.push(total);
  }
  return results;
}

// Calculates annual growth rate
// formula for Cumulative Annual Growth Rate
export const calculateCumulativeAnnualGrowthRate = (start: number, end: number, duration: number): number => {

  const durationInverse = 1 / duration;
  return Math.pow((end / start), durationInverse) - 1;
}



// WEBPACK FOOTER //
// ./src/services/statistics.ts